import { ChangeEvent, KeyboardEvent, useEffect, useState } from 'react';
import { DropdownProps, useDayPicker } from 'react-day-picker';

import { NON_NUMERIC_REGEX } from '@/constants';

import { Input } from '@/components/common';

import { CALENDAR_MAX_YEAR_FROM_NOW, CALENDAR_MIN_YEAR_FROM_NOW } from '../Calendar.constants';

export const YearsDropdown = (props: DropdownProps) => {
  const { value, onChange, 'aria-label': ariaLabel } = props;
  const dayPickerProps = useDayPicker().dayPickerProps;
  const minYear = dayPickerProps.startMonth
    ? dayPickerProps.startMonth.getFullYear()
    : new Date().getFullYear() - CALENDAR_MIN_YEAR_FROM_NOW;
  const maxYear = dayPickerProps.endMonth
    ? dayPickerProps.endMonth.getFullYear()
    : new Date().getFullYear() + CALENDAR_MAX_YEAR_FROM_NOW;

  const [inputValue, setInputValue] = useState(value);

  useEffect(() => {
    setInputValue(value);
  }, [value]);

  // Handle value changes with clamping to min/max year
  const applyChanges = (newValue: string) => {
    const newValueNum = Number(newValue);
    const clampedValue = Math.max(minYear, Math.min(maxYear, newValueNum)).toString();

    if (onChange) {
      const syntheticEvent = {
        target: { value: clampedValue },
      } as ChangeEvent<HTMLSelectElement>;

      onChange(syntheticEvent);
    }
  };
  const onInputChange = (e: ChangeEvent<HTMLInputElement>) => {
    const newValue = e.target.value.replace(NON_NUMERIC_REGEX, '');
    const oldNum = Number(inputValue);
    const newNum = Number(newValue);

    // Check if the change is from arrow buttons (increment/decrement by 1)
    const isStepButtonChange = Math.abs(newNum - oldNum) === 1;

    if (isStepButtonChange) {
      // Apply change immediately for arrow buttons
      applyChanges(newValue);
    } else {
      // Just update local state for manual typing
      setInputValue(newValue);
    }
  };

  const onKeyDown = (e: KeyboardEvent<HTMLInputElement>) => {
    if (e.key === 'Enter' && inputValue) {
      applyChanges(inputValue.toString());
    }
  };

  return (
    <Input
      aria-label={ariaLabel}
      value={inputValue}
      className="max-w-[62px] [&_input]:h-[32px] [&_input]:border-transparent dark:[&_input]:border-transparent [&_input]:text-primary-base dark:[&_input]:text-primary-base [&_input]:px-s [&_input]:py-xs [&_input]:font-semibold"
      onChange={onInputChange}
      onBlur={(e) => applyChanges(e.target.value)}
      onKeyDown={onKeyDown}
      size="default"
    />
  );
};
